module.exports = __webpack_public_path__ + "static/media/hm.fe514431.svg";